<div>
    <h2>{{'mantenimientoPaises.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{ 'show-error': showError }">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}}</label>
                <input type="text" formControlName="pais">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoPaises.filters.isO3' | translate}}</label>
                <input type="text" formControlName="isO3">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left-small move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
                <input type="checkbox" id="esProductor" formControlName="esProductor">
                <label for="esProductor">{{'mantenimientoPaises.filters.productor' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
                <input type="checkbox" id="esDestino" formControlName="esDestino">
                <label for="esDestino">{{'mantenimientoPaises.filters.destino' | translate}}</label>
            </div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id sortable" (click)="toOrderBy('x=> x.id', 1)">
                          {{'mantenimientoPaises.table.id' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.id')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.PaisIdiomas.Where(y=> y.IdiomaId == ' + this.idiomaId + ').FirstOrDefault().DesPais ?? x.DesPaisDefecto', 2)">
                          {{'global.pais' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.PaisIdiomas.Where(y=> y.IdiomaId == ' + this.idiomaId + ').FirstOrDefault().DesPais ?? x.DesPaisDefecto')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.isO3', 3)">
                          {{'mantenimientoPaises.table.isO3' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.isO3')"></i></div>
                        </th>
                        <th class="string">{{'mantenimientoPaises.table.productor' | translate}}</th>
                        <th class="string">{{'mantenimientoPaises.table.destino' | translate}}</th>
                        <th class="date-long sortable" (click)="toOrderBy('x=> x.fechaIns', 6)">
                          {{'global.fecha.insercionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                        </th>
                        <th class="date-long sortable" (click)="toOrderBy('x=> x.fechaUpd', 7)">
                          {{'global.fecha.actualizacionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaUpd')"></i></div>
                        </th>
                        <th class="action"><i class="fas fa-plus" (click)="create()" title="{{'mantenimientoPaises.tituloNew' | translate}}"></i></th>
                    </tr>
                </thead>
                <tbody *ngFor="let pais of paises; let i=index; trackBy: trackByPaisId">
                    <tr>
                        <td class="id">{{pais.id}}</td>
                        <td class="string">{{pais.desPaisDefecto}}</td>
                        <td class="string">{{pais.isO3}}</td>
                        <td class="icon">
                            <i *ngIf="pais.esProductor" class="fa-regular fa-circle-check" title="{{'mantenimientoPaises.table.paisProductor' | translate}}"></i>
                        </td>
                        <td class="icon">
                            <i *ngIf="pais.esDestino" class="fa-regular fa-circle-check" title="{{'mantenimientoPaises.table.paisDestino' | translate}}"></i>
                        </td>
                        <td class="date-long">{{pais.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date-long">{{pais.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="multi-actions">
                            <i class="fas fa-stream" app-click-stop-propagation  (click)="openTabs(i)"
                                title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                            <i class="fas fa-pencil-alt" app-click-stop-propagation  (click)="update(pais)" title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" app-click-stop-propagation  (click)="askDelete(pais)" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="8">
                            <section class="tabs">
                                <ul>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showSection(i, pais)">{{'mantenimientoPaises.table.tabs.traducciones' | translate}}</li>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showAsociarMunicipios(i)">{{'mantenimientoPaises.table.tabs.listaProvincias.titulo' | translate}}</li>
                                </ul>
                                <content>
                                    <app-asociar-traducciones *ngIf="pestanaActiva[i] === 1" [objeto]="pais" [nombreComponente]="this.nombreComponente" (refresh)="toRefresh($event)"></app-asociar-traducciones>
                                    <app-lista-provincias *ngIf="pestanaActiva[i] === 2" [id]="pais.id" (refresh)="toRefresh($event)" (pushMessage)="pushMessage($event)"></app-lista-provincias>
                                </content>
                            </section>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!paises || (paises && paises.length < 1)">
                    <tr>
                      <td colspan="8">
                        {{ 'global.noContent' | translate }}
                      </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="paises && paises.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
            <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{toEditId ? ('mantenimientoPaises.tituloEdit' | translate) : ('mantenimientoPaises.tituloNew' | translate)}}</h4>
        </header>
        <app-pss-new-edit [paisId]="toEditId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-pss-new-edit>
    </div>
</div>
